import {
	MOBILE_SDK_DOCUMENTATION_LINK,
	MobileSdkDocumentationLink,
	MobileSdkInfo
} from 'src/apps/mobile-sdk/types/MobileSdkHelpersTypes';
import { IEvBreadcrumb } from 'src/common/components/ev-breadcrumbs/EvBreadcrumbs';
import { MOBILE_SDK_TYPES, MobileSdkTypes } from 'src/common/helpers/MobileQueriesHelper';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { getBaseURL } from 'src/common/helpers/UrlNormalizingHelper';

const MAIN_PAGE_NAV_LABEL = 'All Tests';

export const getMobileSdkBreadcrumbRoutes = (testId: string, testName: string): IEvBreadcrumb[] => [
	{
		id: MAIN_PAGE_NAV_LABEL,
		url: RoutesHelper.getMobileSdkDashboardPath(),
		title: MAIN_PAGE_NAV_LABEL
	},
	{
		id: testId,
		url: '',
		title: testName
	}
];

export const getCurrentMobileSdkFullUrl = (testId: string): string =>
	`${getBaseURL()}${RoutesHelper.getMobileSdkTestRootPath(testId)}`;

export const MOBILE_SDK_INFO: MobileSdkInfo[] = [
	{
		label: MOBILE_SDK_TYPES.APPIUM_JAVA,
		version: '1.38.0'
	},
	// will be uncommented since the SDK is ready
	// {
	// 	label: MOBILE_SDK_TYPES.APPIUM_PYTHON,
	// 	version: '1.23.0'
	// },
	{
		label: MOBILE_SDK_TYPES.ESPRESSO,
		version: '1.32.0'
	},
	{
		label: MOBILE_SDK_TYPES.WDIO_MOBILE,
		version: '1.28.0'
	},
	{
		label: MOBILE_SDK_TYPES.XCUI,
		version: '1.32.0'
	}
];

export const DOCUMENTATION_LINKS_MAP: Record<MobileSdkTypes, MobileSdkDocumentationLink> = {
	[MOBILE_SDK_TYPES.APPIUM_JAVA]: MOBILE_SDK_DOCUMENTATION_LINK.APPIUM_JAVA,
	[MOBILE_SDK_TYPES.APPIUM_PYTHON]: MOBILE_SDK_DOCUMENTATION_LINK.APPIUM_PYTHON,
	[MOBILE_SDK_TYPES.ESPRESSO]: MOBILE_SDK_DOCUMENTATION_LINK.ESPRESSO,
	[MOBILE_SDK_TYPES.WDIO_MOBILE]: MOBILE_SDK_DOCUMENTATION_LINK.WDIO_MOBILE,
	[MOBILE_SDK_TYPES.XCUI]: MOBILE_SDK_DOCUMENTATION_LINK.XCUI
};

export const getAllTestsTooltipText = (): string => {
	const sdkText = MOBILE_SDK_INFO.map(({ label, version }) => `${label} ${version}`).join(', ');
	return `Reports here are available for the following Mobile SDK versions and newer: ${sdkText}. To see reports from previous SDK versions, go to the Old Platform.`;
};
